import {
  Button,
  IconButton,
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  makeStyles,
  Typography
} from "@material-ui/core";
import { Delete as DeleteIcon } from "@material-ui/icons";
import classNames from "classnames";
import moment from "moment";
import React from "react";
import { useIntl } from "react-intl";
import { Link as RouterLink } from "react-router-dom";
import { dateTimeInterval } from "../../ducks/utils";

const useStyles = makeStyles(theme => ({
  programEventRow: {
    backgroundColor: "#cdcdcd",
    borderRadius: "0.5rem",
    margin: "0.25rem 0",
    "& > *": {
      marginRight: "1rem"
    }
  },
  programEventRowPast: {
    "& > *": {
      color: "grey",
      textDecoration: "line-through"
    }
  },
  programEventBody: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    flex: "1 1",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column"
    },
    "& > *": {
      marginRight: "1rem"
    }
  },
  time: {
    "& > strong": {
      color: "#0a0a2d"
    },
    "& > span": {
      marginLeft: "1.2em"
    }
  },
  text: {
    textAlign: "center"
  }
}));

const EventListItem = ({ programEvent, onDelete = () => {} }) => {
  const intl = useIntl();
  const classes = useStyles();

  const isPast = moment(programEvent.endAt).add(30, "minutes").isBefore();
  const isLive = !isPast && moment(programEvent?.startAt).subtract(30, "minutes").isBefore();

  return (
    <ListItem
      key={programEvent.id}
      className={classNames(classes.programEventRow, {
        [classes.programEventRowPast]: isPast
      })}
    >
      <ListItemIcon />

      <div className={classes.programEventBody}>
        <Typography className={classes.time}>
          <strong>{dateTimeInterval(programEvent.startAt, programEvent.endAt, false)}</strong>
        </Typography>
        <>
          <span className={classes.text}>
            {programEvent.label}
            {intl.formatMessage(
              { id: "Pages.AgendaPage.Room", defaultMessage: "Room {rooms}" },
              { rooms: programEvent.roomList.join(", ") }
            )}
          </span>
          {programEvent.eventable?.type === "session" && (
            <Button
              component={RouterLink}
              to={`/sessions/${programEvent.eventable.id}`}
              color="primary"
              variant="outlined"
              size="small"
              disabled={!isLive}
            >
              {intl.formatMessage({
                id: "Pages.AgendaPage.JoinRoom",
                defaultMessage: "Join Room"
              })}
            </Button>
          )}
        </>
      </div>

      <ListItemSecondaryAction>
        {!isPast && programEvent && (
          <IconButton onClick={onDelete({ id: programEvent.id })}>
            <DeleteIcon />
          </IconButton>
        )}
      </ListItemSecondaryAction>
    </ListItem>
  );
};
export default EventListItem;
